/* eslint-disable react/display-name */
import { LegacyRef, forwardRef } from "react";

type IconButtonProps = {
  fontSize: number;
  className: string | undefined;
  iconName: string;
  onClick?: () => void;
  onMouseEnter?: () => void;
  onMouseLeave?: () => void;
};

const IconButton = forwardRef((props: IconButtonProps, ref: LegacyRef<HTMLDivElement>) => {
  const { fontSize, className, iconName, onClick, onMouseEnter, onMouseLeave } = props;
  return (
    <div className="click center column" ref={ref}>
      <i
        className={`${className} ${iconName} click`}
        style={{ fontSize: fontSize }}
        onClick={onClick}
        onMouseEnter={onMouseEnter}
        onMouseLeave={onMouseLeave}
      />
    </div>
  );
});

export { IconButton };
